const SortOption = {
  YEARS_HIGH_TO_LOW: "years-high-to-low",
  YEARS_LOW_TO_HIGH: "years-low-to-high",
};

export const sortOffersByYears = (offers, sortOption) => {
  if (!offers || !offers.length) return [];

  return [...offers].map((offer) => {
    const newOffer = { ...offer };

    const bulkPaymentDetails = Array.isArray(offer.bulk_payment_details)
      ? [...offer.bulk_payment_details]
      : Object.values(offer.bulk_payment_details);

    newOffer.bulk_payment_details = sortBulkPaymentDetails(
      bulkPaymentDetails,
      sortOption
    );

    return newOffer;
  });
};

export const sortBulkPaymentDetails = (bulkPaymentDetails, sortOption) => {
  if (!bulkPaymentDetails || !bulkPaymentDetails.length) return [];

  return [...bulkPaymentDetails].sort((a, b) => {
    if (sortOption === SortOption.YEARS_HIGH_TO_LOW) {
      return b.years - a.years;
    } else if (sortOption === SortOption.YEARS_LOW_TO_HIGH) {
      return a.years - b.years;
    }
    return 0;
  });
};
